<div>
  <select class="form-select" [formControl]="brandInputCtrl" aria-label="Select Brand">
    <option value="" >Select Brand</option>
    <option [value]="brand.id" *ngFor="let brand of brandList">{{brand.name}}</option>
  </select>
</div>
